import { entities } from "sbtech-sports-data-api-client";
import * as Models from "../../Models";

export function parseMarket(market: entities.Market): Models.Market {
    return new Models.Market(
        {
            eventId: market.eventId,
            id: market.id,
            typeId: market.marketType.id,
            name: market.name,
            selectionIds: getMarketSelectionIds(market)
        }
    );
}

type validSelectionsMarket =
{
    id:string,
    outcomeType:entities.OutcomeType | null
}

function getValidMarket(market: entities.Market)
{
    let validMarket : validSelectionsMarket[] = [];
    market.selections.forEach(selection => {
        if (!selection.isDisabled) {
            let validSelectionsMarket: validSelectionsMarket = {
                id: selection.id,
                outcomeType: selection.outcomeType,
            }
            validMarket.push(validSelectionsMarket);
        }
    });
    return validMarket;
}

export function getMarketSelectionIds(market: entities.Market) {

    return getValidSelections(getValidMarket(market));
}

function getValidSelections(validMarket: validSelectionsMarket[])
{
    let selectionIds: string[] = [];
    // ugly code due to wrong entity property type
    for (let index = 0; index < validMarket.length; index++) {

        switch (validMarket[index].outcomeType) {
            case entities.OutcomeType.Home: {

                selectionIds[0] = validMarket[index].id;
               break;
            }
            case entities.OutcomeType.Tie: {
                selectionIds[1] = validMarket[index].id;
               break;
            }
            case entities.OutcomeType.Away: {
               if (validMarket.length === 2) {
                selectionIds[1] = validMarket[index].id;
               }
               else {
                selectionIds[2] = validMarket[index].id;
               }
               break;
            }
         };
    }

    return selectionIds;
}
